module.exports = {"name":false,"alias":false,"_id":false,"type":"general","dynamic":{},"analytics":false,"colorPalette":[],"favicon":false,"fonts":[],"selectionColor":false,"status":"live","updated":false,"meta":{"image":false},"SSL":{"certs":[]},"cloudFront":{"domain":false,"id":false},"siteTheme":"default","siteBaseColor":{"rgba":"rgba(65, 224, 196, 1)","picker":{"hex":"#41e0c4"}},"domains":[],"siteMap":[],"pages":[],"drafts":[],"templates":[],"linkedBy":{"pages":[],"droplets":[]},"recycled":[],"queue":{"pages":{},"templates":{}},"archived":{"pages":[],"templates":[],"drafts":[],"recycled":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/new-site.json
// module id = 7raP
// module chunks = 0